import React from "react";
import { useTranslation } from "react-i18next";
import BaseTextArea from "../../components/BaseTextArea";
import BaseButton from "../../components/BaseButton";
import useController from "./controller";
import WrapperPage from "../../components/WrapperPage";
import Ellipses from "../../components/Ellipses";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import ReviewSendedModal from "../../modals/ReviewSendedModal";

export default function LeaveReview() {
  const { isFeedbackLoading, reviewValue, setReviewValue, onSubmitHandle } =
    useController();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="leave-review-container">
      <Ellipses countEllipses={1} className="leave-review-ellipses" />
      <ReviewSendedModal />
      <WrapperPage
        onClickBackBtn={() => navigate(-1)}
        backBtn
        burgerMenu
      >
        <div className="leave-review-container__form-wrapper">
          <div>
            <div
              className="leave-review-container__title neon-text"
              data-text={t("leave_review.title")}
            >
              {t("leave_review.title")}
            </div>
            <div className="leave-review-container__desc">
              {t("leave_review.desc")}
            </div>
            <div className="leave-review-container__desc">
              {t("leave_review.desc1")}
            </div>
            <form
              className="leave-review-container__form"
            >
              <BaseTextArea
                name="text"
                value={reviewValue}
                className="leave-review-container__form--textarea"
                placeholder={t("leave_review.placeholder")}
                onChange={(event) => {
                  setReviewValue(event.target.value);
                }}
              />
              <BaseButton
                onClick={onSubmitHandle}
                disabled={!reviewValue.length}
                loading={isFeedbackLoading}
                className="leave-review-container__form__submit"
              >
                {t("send")}
              </BaseButton>
            </form>
          </div>
        </div>
      </WrapperPage>
    </div>
  );
}
